import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { InfluxService } from "../../services/api/influx.service";
import { map, Observable, Subscription, switchMap, tap } from "rxjs";

export interface Alarm {
  id: string;
  stationCode: string;
  timestamp: string; // or Date, if your API returns an ISO timestamp
  devName: string;
  muted: boolean;
  stationName: string;
  alarmCause: string;
  alarmName: string;
  // …any other fields your API returns
}
@Component({
  selector: "app-notify",
  templateUrl: "./notify.component.html",
  styleUrls: ["./notify.component.scss"],
})
export class NotifyComponent implements OnInit, OnDestroy {
  showReasonInput: boolean = false;
  muteReason: string = "";
  time: string = "";
  stationcode: string = "";
  message: string = "";
  muted: boolean = false;
  followAlarm: boolean = false;
  formSubmitted = false;
  // alarm$!: Observable<Alarm>;
  public alarm!: Alarm;
  id!: string;
  private subs = new Subscription();
  constructor(
    private route: ActivatedRoute,
    private influxService: InfluxService
  ) {}
  ngOnInit() {
    // Subscribe to queryParams directly
    this.subs.add(
      this.route.queryParams
        .pipe(
          tap((params) => {
            // 1) reset UI whenever id changes
            this.id = params["id"];
            this.muteReason = "";
            this.showReasonInput = false;
          }),
          switchMap((params) =>
            // 2) load the new alarm
            this.influxService.getAlarmDetails(params["id"])
          )
        )
        .subscribe((alarm) => {
          // 3) assign for your template to consume
          this.alarm = alarm;
        })
    );
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  // ngOnInit(): void {
  //   this.route.queryParams
  //     .pipe(
  //       map((params) => params["id"]), // grab id
  //       switchMap((id) => {
  //         this.id = id; // if you still need to keep it
  //         return this.influxService.getAlarmDetails(id); // returns Observable<Alarm>
  //       })
  //     )
  //     .subscribe((alarm) => {
  //       this.alarm = alarm;
  //       // now you have a concrete Alarm instance
  //     });
  //   // this.route.queryParams.subscribe((params) => {
  //   //   this.id = params["id"];
  //   //   // this.time = params["time"];
  //   //   // this.stationcode = params["stationcode"];
  //   //   // this.message = params["message"];
  //   // });
  // }

  saveMuteReason() {
    this.formSubmitted = true;
    if (!this.muteReason || this.muteReason.trim() === "") {
      // Form is invalid, don't proceed
      return;
    }
    // Proceed with logic
    const username = localStorage.getItem("username")?.trim();
    // Call API to Mute This

    const body = {
      // time: this.time, // UTC time as string, e.g. "2025-05-19T10:25:52"
      // stationCode: this.stationcode,
      id: this.id,
      mutedBy: username,
      muteReason: this.muteReason,
      followAlarm: this.followAlarm,
    };
    // Call the service
    this.influxService.muteAlarm(body).subscribe({
      next: (res) => {
        // Reset flag if needed
        this.formSubmitted = false;
        // this.muted = true;
        this.alarm.muted = true;
        this.muteReason = "";
        this.showReasonInput = false;
        // Optionally show a toast or update UI
      },
      error: (err) => {
        console.error("Error muting alarm:", err);
        // Show error message to user
      },
    });
  }

  notifyAlarm() {
    const username = localStorage.getItem("username")?.trim();
    const body = {
      id: this.id,
      mutedBy: username
    };
    this.influxService.notifyAlarm(body).subscribe({
      next: (res) => {
        // console.log("Alarm Notified successfully:", res);
        this.alarm.muted = false;
      },
      error: (err) => {
        console.error("Error muting alarm:", err);
      },
    });
}
}
